// src/pages/OrdineConfermato.js
import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { usePayment } from '../components/hooks/hooks-e-commerce/usePayment';
import './ordine-confermato.scss';

function OrdineConfermato() {
    const location = useLocation();
    const navigate = useNavigate();
    const { confirmPayment } = usePayment();
    const [orderData, setOrderData] = useState(null);
    const [loading, setLoading] = useState(true);
    
    useEffect(() => {
        const fetchOrderData = async () => {
            try {
                const urlParams = new URLSearchParams(window.location.search);
                const orderId = urlParams.get('orderId');
                const sessionId = urlParams.get('session_id');  // ← QUESTO è il parametro di Stripe Checkout!
                const success = urlParams.get('success');
                
                console.log('🔍 URL params:', { orderId, sessionId, success });
                
                if (!orderId) {
                    console.error('❌ orderId non trovato');
                    setLoading(false);
                    return;
                }
                
                // ✅ 1. PRIORITÀ ASSOLUTA A sessionStorage
                const savedOrderData = sessionStorage.getItem('orderData');
                if (savedOrderData) {
                    try {
                        const parsed = JSON.parse(savedOrderData);
                        console.log('📦 Ordine trovato in orderData:', parsed);
                        
                        if (parsed.order.numero_ordine === orderId) {
                            setOrderData({
                                order: parsed.order,
                                paymentMethod: parsed.paymentMethod || 'card',
                                success: true,
                                fromSession: true
                            });

                            // ✅ CORREZIONE: usa sessionId, NON paymentIntent!
                            if (sessionId && parsed.paymentMethod === 'card') {
                                console.log('💰 Confermo pagamento Stripe con session_id:', sessionId);
                                try {
                                    await confirmPayment(
                                        orderId,
                                        sessionId,  // ← transactionId = session_id
                                        'card',
                                        {
                                            scontoSpedizione: parsed.order.sconto_spedizione || 0,
                                            scontoTipo: parsed.order.sconto_tipo || null,
                                            importoTotale: parsed.order.importo_totale || 0,
                                            costoSpedizione: parsed.order.costo_spedizione || 0,
                                            importoIva: parsed.order.importo_iva || 0
                                        }
                                    );
                                    console.log('✅ Pagamento confermato con successo!');
                                } catch (error) {
                                    console.error('❌ Errore conferma pagamento:', error);
                                }
                            } else {
                                console.warn('⚠️ sessionId non trovato, pagamento non confermato');
                            }
                            
                            // Pulisci sessionStorage DOPO aver letto
                            sessionStorage.removeItem('orderData');
                            sessionStorage.removeItem('pendingOrder');
                            
                            await clearCartDirectly();
                            setLoading(false);
                            return;
                        }
                    } catch (e) {
                        console.error('Errore parsing sessionStorage:', e);
                    }
                }
                
                // ✅ 2. SOLO SE sessionStorage è vuoto, recupera dal backend
                console.log('⚠️ sessionStorage vuoto, leggo dal backend');
                const API_URL = process.env.REACT_APP_API_URL || '/api';
                
                try {
                    const response = await axios.get(`${API_URL}/orders/${orderId}`, {
                        withCredentials: true
                    });
                    
                    console.log('✅ Ordine recuperato dal backend:', response.data.order);
                    
                    const order = response.data.order;
                    const convertedOrder = {
                        ...order,
                        subtotale: parseFloat(order.subtotale) || 0,
                        costo_spedizione: parseFloat(order.costo_spedizione) || 0,
                        spese_imballaggio: parseFloat(order.spese_imballaggio) || 0,
                        importo_iva: parseFloat(order.importo_iva) || 0,
                        importo_totale: parseFloat(order.importo_totale) || 0,
                        sconto_spedizione: parseFloat(order.sconto_spedizione) || 0,
                        sconto_tipo: order.sconto_tipo || null
                    };
                    
                    setOrderData({
                        order: convertedOrder,
                        paymentMethod: 'card',
                        success: success === 'true'
                    });
                    
                    // ✅ ANCHE QUI: conferma pagamento con session_id
                    if (sessionId) {
                        console.log('💰 Confermo pagamento Stripe (backup) con session_id:', sessionId);
                        try {
                            await confirmPayment(
                                orderId,
                                sessionId,
                                'card',
                                {
                                    scontoSpedizione: convertedOrder.sconto_spedizione || 0,
                                    scontoTipo: convertedOrder.sconto_tipo || null,
                                    importoTotale: convertedOrder.importo_totale || 0,
                                    costoSpedizione: convertedOrder.costo_spedizione || 0,
                                    importoIva: convertedOrder.importo_iva || 0
                                }
                            );
                            console.log('✅ Pagamento confermato con successo (backup)!');
                        } catch (error) {
                            console.error('❌ Errore conferma pagamento (backup):', error);
                        }
                    }
                    
                    await clearCartDirectly();
                } catch (error) {
                    console.error('❌ Errore recupero ordine:', error);
                }
                
            } catch (error) {
                console.error('❌ Errore fetch ordine:', error);
            } finally {
                setLoading(false);
            }
        };
        
        const clearCartDirectly = async () => {
            try {
                const API_URL = process.env.REACT_APP_API_URL || '/api';
                console.log('🗑️ Svuotamento carrello in corso...');
                
                await axios.delete(`${API_URL}/cart/clear`, {
                    withCredentials: true
                });
                
                console.log('✅ Carrello svuotato con successo');
                localStorage.removeItem('cart');
                window.dispatchEvent(new CustomEvent('cartUpdated', { 
                    detail: { items: [], subtotal: 0, item_count: 0 } 
                }));
            } catch (error) {
                console.error('❌ Errore svuotamento carrello:', error);
            }
        };
        
        fetchOrderData();
        
    }, [confirmPayment, location]);
    
    if (loading) {
        return (
            <div className="confermato-container">
                <div className="loading-spinner"></div>
                <p>Completamento ordine...</p>
            </div>
        );
    }
    
    if (!orderData || !orderData.order) {
        return (
            <div className="confermato-container error">
                <div className="error-icon">❌</div>
                <h2>Nessun ordine trovato</h2>
                <p>Non è stato possibile trovare i dettagli del tuo ordine.</p>
                <button className="continue-btn" onClick={() => navigate('/negozioonline')}>
                    Torna al catalogo
                </button>
            </div>
        );
    }
    
    const { order } = orderData;
    
    const subtotale = order.subtotale || 0;
    const costoSpedizione = order.costo_spedizione || 0;
    const speseImballaggio = order.spese_imballaggio || 0;
    const importoIva = order.importo_iva || 0;
    const importoTotale = order.importo_totale || 0;
    const scontoSpedizione = order.sconto_spedizione || 0;
    const scontoTipo = order.sconto_tipo;
    const hasDiscount = scontoSpedizione > 0;
    const prezzoSpedizioneOriginale = costoSpedizione + scontoSpedizione;
    
    return (
        <div className="confermato-container">
            <div className="success-icon">✅</div>
            <h1>Ordine Confermato!</h1>
            <p className="success-message">Il tuo ordine è stato ricevuto con successo.</p>
            
            <div className="order-details">
                <div className="detail-row">
                    <span>Numero ordine:</span>
                    <strong>{order.numero_ordine}</strong>
                </div>
                <div className="detail-row">
                    <span>Data:</span>
                    <strong>{order.data_creazione ? new Date(order.data_creazione).toLocaleDateString('it-IT') : new Date().toLocaleDateString('it-IT')}</strong>
                </div>
                <div className="detail-row total">
                    <span>Totale pagato:</span>
                    <strong>€ {importoTotale.toFixed(2)}</strong>
                </div>
            </div>
            
            <div className="order-summary">
                <div className="summary-row">
                    <span>Subtotale prodotti:</span>
                    <span>€ {subtotale.toFixed(2)}</span>
                </div>
                
                {speseImballaggio > 0 && (
                    <div className="summary-row">
                        <span>Imballaggio:</span>
                        <span>€ {speseImballaggio.toFixed(2)}</span>
                    </div>
                )}
                
                {hasDiscount ? (
                    <>
                        <div className="summary-row">
                            <span>Spedizione:</span>
                            <div style={{ display: 'flex', gap: '8px', justifyContent: 'flex-end' }}>
                                <span style={{ textDecoration: 'line-through', color: '#999' }}>
                                    € {prezzoSpedizioneOriginale.toFixed(2)}
                                </span>
                                <span style={{ color: '#2e7d32', fontWeight: 'bold' }}>
                                    € {costoSpedizione.toFixed(2)}
                                </span>
                            </div>
                        </div>
                        <div className="summary-row" style={{ color: '#2e7d32' }}>
                            <span>🎉 Sconto {scontoTipo === 'abruzzo_50' ? 'Abruzzo' : 'spedizione'}:</span>
                            <span style={{ color: '#c62828' }}>-€ {scontoSpedizione.toFixed(2)}</span>
                        </div>
                    </>
                ) : (
                    <div className="summary-row">
                        <span>Spedizione:</span>
                        <span>€ {costoSpedizione.toFixed(2)}</span>
                    </div>
                )}
                
                <div className="summary-row">
                    <span>IVA:</span>
                    <span>€ {importoIva.toFixed(2)}</span>
                </div>
            </div>
            
            <div className="actions">
                <button 
                    className="continue-btn"
                    onClick={() => navigate('/negozioonline')}
                >
                    🛍️ Continua lo shopping
                </button>
            </div>
        </div>
    );
}

export default OrdineConfermato;